import {axiosRequestData} from '../../helpers/axios';

const API_ENDPOINT = '/wp-json/pg/v2/sc/score-tracker';

const fetchData = async (dateFrom, dateTo) => {
    try {
        const response = await axiosRequestData('GET', API_ENDPOINT + "?date_from=" + dateFrom + "&date_to=" + dateTo);

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export default fetchData;
